import React, {useEffect} from 'react'
import localization from "../../../assets/localization/localization";
import DropDownInput from "../../../components/sales/Input/dropDownInput/dropDownInput";
import FormSection from "../../../components/sales/formSection/formSectionNew";

/**
 *
 * @param RevenueData
 * @param handleValue
 * @param commercialData
 * @param isEditable
 * @returns {JSX.Element}
 * @constructor
 */
const B2BRevenue = (
    {
        RevenueData = [],
        handleValue = () => {},
        commercialData = [],
        isEditable = false
    }
) => {
    useEffect(() => {
        if (commercialData?.revenue_nature !== undefined &&
            commercialData?.revenue_nature !== null &&
            commercialData?.revenue_nature !== '') {
            handleValue('revenue_nature', commercialData?.revenue_nature)
        }

        // if (commercialData?.invoice_type !== undefined &&
        //     commercialData?.invoice_type !== null &&
        //     commercialData?.invoice_type !== '') {
        //     handleValue('invoice_type', commercialData?.invoice_type)
        // }
        //
        // if (commercialData?.revenue_type !== undefined &&
        //     commercialData?.revenue_type !== null &&
        //     commercialData?.revenue_type !== '') {
        //     handleValue('revenue_type', commercialData?.revenue_type)
        // }
    }, [commercialData])

    return (
        <>
            <FormSection title={localization.Revenue}>
                <DropDownInput
                    data={RevenueData?.nature}
                    label={localization.revenueNature}
                    required
                    isStarRequired={true}
                    errorMsg={localization.requiredRevenueNature}
                    getIdValue={(val) => handleValue('revenue_nature', val?.id)}
                    value={commercialData?.revenue_nature !== undefined && commercialData?.revenue_nature !== null ? commercialData?.revenue_nature : 'Self'}
                    disabled={isEditable}
                />
                {/*<DropDownInput*/}
                {/*    data={RevenueData?.type}*/}
                {/*    label={localization.revenueType}*/}
                {/*    required*/}
                {/*    isStarRequired={true}*/}
                {/*    errorMsg={localization.requiredRevenueType}*/}
                {/*    getIdValue={(val) => handleValue('revenue_type', val?.id)}*/}
                {/*    value={commercialData?.revenue_type}*/}
                {/*    disabled={isEditable}*/}
                {/*/>*/}
                {/*<DropDownInput*/}
                {/*    data={RevenueData?.invoice_type}*/}
                {/*    label={localization.revenueInvoiceType}*/}
                {/*    required*/}
                {/*    isStarRequired={true}*/}
                {/*    errorMsg={localization.requiredRevenueInvoice}*/}
                {/*    getIdValue={(val) => handleValue('invoice_type', val?.id)}*/}
                {/*    value={commercialData?.invoice_type}*/}
                {/*    disabled={isEditable}*/}
                {/*/>*/}
            </FormSection>
        </>
    )
}

export default B2BRevenue